export const dutch = {
  lang: 'nl',
  data: {
    LEDGER: {
      USERS: 'Gebruikers',
      ACTIVE: 'Actief',
      BLOCKED: 'Geblokkeerd',
      INVITED: 'Uitgenodigd',
      DOCS: 'Documenten',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/main/content/ledger/i18n/nl.ts